var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 21.362,
    viewBox: "0 0 25 21.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 25,
    height: 21.362,
    fill: "#363636"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M11.03,2.751a.844.844,0,0,0,0,1.194,5.709,5.709,0,0,1,0,8.058A.845.845,0,1,0,12.221,13.2a7.4,7.4,0,0,0,0-10.447.844.844,0,0,0-1.194,0",
    transform: "translate(5.333 1.239)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M8.916,4.372a.844.844,0,0,0,0,1.194,2.275,2.275,0,0,1,0,3.212A.845.845,0,0,0,10.11,9.973a3.968,3.968,0,0,0,0-5.6.844.844,0,0,0-1.194,0",
    transform: "translate(4.289 2.041)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M14.727.248a.845.845,0,0,0-1.194,1.194,11.008,11.008,0,0,1,0,15.541.845.845,0,0,0,1.194,1.194,12.7,12.7,0,0,0,0-17.93",
    transform: "translate(6.571 0.001)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M6.146,12.577a4.184,4.184,0,1,0-.58,0,5.9,5.9,0,0,0-4.057,1.673A5.652,5.652,0,0,0,0,18.451a.845.845,0,0,0,.845.825H10.865a.845.845,0,0,0,.845-.825,5.665,5.665,0,0,0-1.508-4.2,5.9,5.9,0,0,0-4.055-1.671M3.361,8.4a2.495,2.495,0,1,1,2.495,2.5A2.5,2.5,0,0,1,3.361,8.4M1.731,17.587a3.648,3.648,0,0,1,.988-2.157,4.309,4.309,0,0,1,3.138-1.169,4.316,4.316,0,0,1,3.138,1.167,3.646,3.646,0,0,1,.987,2.158Z",
    transform: "translate(0 2.085)",
    fill: "#363636"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup8);
export default __webpack_public_path__ + "static/media/Group 8.d82bf4c732f3a2595c08fcf5b0f21d39.svg";
export { ForwardRef as ReactComponent };